var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 582.2 134.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#231f20;}.cls-6{mask:url(#mask);}.cls-7{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -12489.46,
    y1: 17728.27,
    x2: -9572.3,
    y2: 17213.91,
    gradientTransform: "matrix(-0.01, -0.01, -0.01, 0.01, 157.03, -347.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1523.43,
    y1: -17507.69,
    x2: 187.14,
    y2: -16520.08,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, 27.8, -263.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2384.81,
    y1: -17696.48,
    x2: 4985.57,
    y2: -15514.19,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, 27.8, -263.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -17,
    y: -9.19,
    width: 184.5,
    height: 154,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17-9.19H167.5v154H-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.2,53.91a2.3,2.3,0,0,1-1.4-.4L5.2,45.61A2.94,2.94,0,0,1,3.8,42a2.81,2.81,0,0,1,3.7-1.7c.2.1.3.1.5.2l13.6,7.9a3.09,3.09,0,0,1,1.3,3.9A3.15,3.15,0,0,1,20.2,53.91Zm23.6-23.5A3.08,3.08,0,0,1,41.3,29l-7.9-13.6a3.07,3.07,0,0,1,.6-3.8,3,3,0,0,1,4.1.3h0c.1.1.2.3.3.4l7.9,13.6a3,3,0,0,1-.8,4A3.69,3.69,0,0,1,43.8,30.41ZM73,18.71V3.21A3.13,3.13,0,0,1,75.8.11a2.9,2.9,0,0,1,3,2.8v16a2.9,2.9,0,0,1-2.9,2.9h-.1A3.13,3.13,0,0,1,73,18.71Zm35.1,11.7a2.77,2.77,0,0,1-1.6-.5,3.08,3.08,0,0,1-.8-4l7.9-13.6a2.85,2.85,0,0,1,3.9-1.1c.1.1.3.2.4.3a3.07,3.07,0,0,1,.6,3.8l-7.9,13.6A3,3,0,0,1,108.1,30.41Zm23.5,23.5a2.83,2.83,0,0,1-1.3-5.4l13.5-7.8a3,3,0,0,1,3.7.5,3,3,0,0,1-.3,4.1h0c-.1.1-.3.2-.4.3L133,53.51A2.3,2.3,0,0,1,131.6,53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.3,119.81a51.76,51.76,0,0,1,73.2-73.2,58.68,58.68,0,0,1,4.1,4.6c.9,1.1,1.7,2.3,2.5,3.5l-4.8,3.2a34.57,34.57,0,0,0-2.2-3.1,47.22,47.22,0,0,0-3.7-4.1,46,46,0,0,0-65.1,65.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.8,135H33.1A33.42,33.42,0,0,1-.1,101.31H5.7a27.7,27.7,0,0,0,27.5,27.9h79.6A33.78,33.78,0,0,0,138,72.91l4.3-3.8A39.49,39.49,0,0,1,112.8,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.7,101.31H-.1a33.44,33.44,0,0,1,27.9-32.7l1,5.7A27.56,27.56,0,0,0,5.7,101.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.1,95.21H73.3a39.52,39.52,0,0,1,69-26.1l-4.3,3.8a33.71,33.71,0,0,0-58.9,22.3Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1528.77,
    y1: -6377.68,
    x2: -614.32,
    y2: -10089.63,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, 60.39, -219.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50ffd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IBM_Cloud",
    "data-name": "IBM Cloud",
    className: "cls-5",
    d: "M191.3,112.51v-5.9h8.2V59.71h-8.2v-5.9h23.5v5.9h-8.2v46.9h8.2v5.9Zm36.4-58.7h24.1c9.7,0,15.6,6,15.6,15.1,0,8.7-5.6,11.9-9.5,12.4v.5c4.2.3,11.5,3.9,11.5,13.6s-6.5,17-15.1,17H227.7Zm7,25.4h16.2c5.5,0,8.9-2.9,8.9-8.1v-2.9c0-5.2-3.4-8.1-8.9-8.1H234.7Zm0,27.1h17.4c6.1,0,9.7-3.2,9.7-9.1v-2.9c0-5.9-3.7-9.1-9.7-9.1H234.7Zm93.4-43.2h-.4l-5,9.8-14,25.5-13.9-25.5-5-9.7h-.4v49.3h-6.9V53.81h9.2l16.8,31.6h.3l16.9-31.6h9.2v58.6H328l.1-49.3Zm35.4,20.5c0-19.8,10.2-30.7,26-30.7,10.8,0,17.6,4.4,21.9,13.8l-11,5.7c-1.5-4.9-4.6-8.1-10.9-8.1-7.5,0-12.4,5-12.4,14.3V88c0,9.2,5,14.3,12.4,14.3,6.3,0,9.9-3.9,11.7-8.7l10.4,6.1c-4.4,8.9-11.3,14-22.1,14C373.7,113.51,363.5,103.41,363.5,83.61Zm68.7,28.9c-8.5,0-12.4-4.3-12.4-12.1V50.31h12.4v52.5h5.5v9.7Zm10.3-22.1c0-14.2,7.7-23,20.7-23s20.7,8.8,20.7,23-7.7,23.1-20.7,23.1S442.5,104.61,442.5,90.41Zm28.4,4.5v-9c0-5.5-2.9-8.7-7.7-8.7s-7.7,3.2-7.7,8.7v9c0,5.5,2.9,8.7,7.7,8.7S470.9,100.51,470.9,94.91Zm47.8,10.2h-.4c-1.5,4.5-5.1,8.4-12.4,8.4-9,0-13.8-6.3-13.8-17.4V68.41h12.4V95c0,5.4,1.8,8.4,6.3,8.4,3.9,0,7.8-2.2,7.8-6.4V68.31H531v44.1H518.6C518.7,112.51,518.7,105.11,518.7,105.11Zm51.1,0h-.4c-1.3,4.8-6.1,8.4-11.9,8.4-11.2,0-17-8.1-17-23.1s5.8-23,17-23c5.7,0,10.6,3.5,11.9,8.4h.4V50.31h12.4v62.2H569.8Zm0-8.2v-13c0-4-3.4-6.5-8.1-6.5s-8.1,3.6-8.1,9.2v7.6c0,5.5,3.4,9.2,8.1,9.2S569.8,101,569.8,96.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.3,53.81a2.3,2.3,0,0,1-1.4-.4L5.3,45.51a2.94,2.94,0,0,1-1.4-3.6,2.81,2.81,0,0,1,3.7-1.7c.2.1.3.1.5.2l13.6,7.9a3.09,3.09,0,0,1,1.3,3.9A3.28,3.28,0,0,1,20.3,53.81Zm23.5-23.5a3.08,3.08,0,0,1-2.5-1.4l-7.9-13.6a3.07,3.07,0,0,1,.6-3.8,3,3,0,0,1,4.1.3h0c.1.1.2.3.3.4l7.9,13.6a3,3,0,0,1-.8,4A3.37,3.37,0,0,1,43.8,30.31Zm29.3-11.7V3.11A3.13,3.13,0,0,1,75.9,0a2.9,2.9,0,0,1,3,2.8v16a2.9,2.9,0,0,1-2.9,2.9h-.1A3.13,3.13,0,0,1,73.1,18.61Zm35.1,11.7a2.77,2.77,0,0,1-1.6-.5,3.08,3.08,0,0,1-.8-4l7.9-13.6a2.85,2.85,0,0,1,3.9-1.1c.1.1.3.2.4.3a3.07,3.07,0,0,1,.6,3.8l-7.9,13.6A3.08,3.08,0,0,1,108.2,30.31Zm23.5,23.5a2.83,2.83,0,0,1-1.3-5.4l13.5-7.8a3,3,0,0,1,3.7.5,3,3,0,0,1-.3,4.1h0c-.1.1-.3.2-.4.3l-13.8,8A3.19,3.19,0,0,1,131.7,53.81Zm-92.3,65.9a51.76,51.76,0,0,1,73.2-73.2,58.68,58.68,0,0,1,4.1,4.6c.9,1.1,1.7,2.3,2.5,3.5l-4.8,3.2a34.57,34.57,0,0,0-2.2-3.1,47.22,47.22,0,0,0-3.7-4.1,46,46,0,0,0-65.1,65.1Zm73.5,15.2H33.2A33.42,33.42,0,0,1,0,101.21H5.8a27.7,27.7,0,0,0,27.5,27.9h79.6a33.78,33.78,0,0,0,25.2-56.3l4.3-3.8a39.56,39.56,0,0,1-3.1,55.9A40.15,40.15,0,0,1,112.9,134.91ZM5.8,101.21H0a33.44,33.44,0,0,1,27.9-32.7l1,5.7A27.56,27.56,0,0,0,5.8,101.21Zm73.3-6.1H73.3a39.52,39.52,0,0,1,69-26.1l-4.3,3.8a33.82,33.82,0,0,0-47.7-2.7A34.32,34.32,0,0,0,79.1,95.11Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/ibm.b71cc19cd3673f10bc998f067c5e79cb.svg";
export { ForwardRef as ReactComponent };